// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { subscribeStyles } from "@awc/Overrides/Widgets/Basic/Subscribe";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import { GridOffset } from "@insite/mobius/GridContainer";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

subscribeStyles.mainGridContainer = {
    gap: 0,
    css: css`
        width: 100%;
        display: flex;
        & > ${GridOffset} {
            flex-direction: column;
            flex-wrap: nowrap;
        }
    `,
};
subscribeStyles.titleLabel = {
    variant: "h4",
    forwardAs: "span",
    color: "common.ui14",
};

subscribeStyles.emailGridItem = {
    width: 12,
    css: css`
        position: relative;
    `,
};

subscribeStyles.emailTextField = {
    mergeCss: true,
    cssOverrides: {
        formInputWrapper: css`
            &&&& input {
                &,
                &:focus {
                    border-radius: 20px;
                    padding-right: 110px;
                    padding-left: 12px;
                }
            }
        `,
    },
};

subscribeStyles.emailButton = {
    mergeCss: true,
    sizeVariant: "large",
    variant: "tertiary",
    typographyProps: {
        size: fontConfig.fontSize.singleLineRegular,
        lineHeight: fontConfig.lineHeight.singleLineSmall,
        color: "common.black",
        css: css`
            color: ${color("common.black")};
        `,
    },
    css: css`
        border-radius: 20px;
        position: absolute;
        right: 0px;
        top: 0px;
        width: 97px;

        & {
            background: ${color("secondary")};
            border-color: ${color("secondary")};
        }

        &&:hover,
        &&:focus {
            background: ${color("common.ui10")};
            border-color: ${color("common.ui10")};
        }
    `,
};

subscribeStyles.titleGridItem = {
    width: 12,
    css: css`
        justify-content: start;
    `,
};

subscribeStyles.descriptionGridItem = {
    width: 12,
    css: css`
        justify-content: start;
        &:empty,
        & span:empty {
            display: none;
        }
    `,
};

subscribeStyles.descriptionText = {
    size: fontConfig.fontSize.xSmall,
    lineHeight: fontConfig.lineHeight.xSmall,
    color: "common.white",
    css: css`
        margin-bottom: 12px;
        ${TypographyStyle} {
            margin-bottom: 0;
            font-size: ${fontConfig.fontSize.xSmall}px;
            line-height: ${fontConfig.lineHeight.xSmall};
        }
    `,
};
